import { userInfoSync } from 'hub-http/userInfo';
export const isInternalEmail = email => email.endsWith('@hubspot.com') || email.endsWith('.hsemailsendingtestqa.com') || email.endsWith('.hsemailsendingtest.com');
export const getIsInternalUser = () => {
  try {
    const {
      user
    } = userInfoSync();
    return isInternalEmail(user.email);
  } catch (_unused) {
    return false;
  }
};